import { Plan, Touchpoint } from '@/constants/enum';
import useUserPlan from '@/hooks/useUserPlan';
import { apiCaller } from '@/redux/query';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Divider } from '@shopify/polaris';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import RecommendedRules from '../RecommendedRules';
import RegularText from '../RegularText';
import WarningBanner from '../WarningBanner';

interface IProps {
  isVisible?: boolean;
  title?: string;
  children?: React.ReactNode;
  touchpoint?: Touchpoint;
  onDismiss?: () => void;
}

const BannerLimit = (props: IProps) => {
  // const navigate = useConfirmationNavigate();
  const dataSettings = useSelector(dataSettingsSelector);
  const isSkip = useSelector(isSkipApiSelector);
  const { isPlanLimited, limitPlan, currentPlan } = useUserPlan();
  const { data: totalRule } = apiCaller.useRuleCountQuery(undefined, { skip: isSkip });
  // const trackTouchPoint = useTrackTouchpoint();

  return isPlanLimited ? (
    <WarningBanner
      title={props.title ?? (dataSettings.plan === Plan.FREE ? 'Free' : 'Standard') + ' Plan Limit'}
      isVisible={props.isVisible ?? isPlanLimited}
      hideContact
      onDismiss={props.onDismiss}
    >
      {props.children ?? (
        <>
          <RegularText>
            You have
            <b>{` ${totalRule?.data?.countRule || 0}/${limitPlan?.maxRule} `}</b>
            {(limitPlan?.maxRule || 0) > 1 ? 'estimate rules' : 'estimate rule'}.
          </RegularText>
          {currentPlan === Plan.FREE ? (
            <div>Upgrade to unlock unlimited rules, advanced display conditions, and more.</div>
          ) : currentPlan === Plan.STANDARD ? (
            <div>Upgrade to unlock unlimited rules, state/province-based conditions, premium auto-detect location, and more.</div>
          ) : null}
        </>
      )}
      {/* <div className="mt-8">
        <Button
          variant="primary"
          onClick={() => {
            navigate(PATH.PRICING_PLAN);
            if (props.touchpoint) {
              trackTouchPoint(props.touchpoint);
            }
          }}
        >
          Upgrade now
        </Button>
      </div> */}
      {props.children ? null : (
        <>
          <div className="mt-8 mb-8">
            <Divider />
          </div>
          <RecommendedRules isInCard reachedRuleLimit={(totalRule?.data?.countRule || 0) >= (limitPlan?.maxRule || 0)} />
        </>
      )}
    </WarningBanner>
  ) : props.children ? null : (
    <div className="mb-12">
      <RecommendedRules reachedRuleLimit={isPlanLimited && (totalRule?.data?.countRule || 0) >= (limitPlan?.maxRule || 0)} />
    </div>
  );
};

export default memo(BannerLimit);
